var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchpage",staticStyle:{"display":"inline-block"}},[_c('Page',{attrs:{"total":_vm.total,"page-size":_vm.rows,"current":_vm.current,"show-elevator":"","show-total":""},on:{"on-change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }